import React, { useEffect, useState } from "react";
import { ConnectedProps } from "react-redux";
import { Select, Input, Table } from "antd";
import moment from "moment";

import { NavigationPath, history, ROLES } from "../../utils";
import ActionButtons from "../ActionButtons/ActionButtons";
import { UsersTableType, getUsersRes } from "../../models";
import { userColumns } from "../../utils/users/userColumns";
import connector from "./Container";

const { Search } = Input;

const Users = ({ state, actions }: ConnectedProps<typeof connector>) => {
  const { users } = state;

  const [usersTable, setUsersTable] = useState<UsersTableType[]>([]);
  const [searchUser, setSearchUser] = useState("");
  const [searchRole, setSearchRole] = useState("");
  const [selected, setSelected] = useState<UsersTableType[] | null>(null);

  useEffect(() => {
    actions.getUsers();
  }, []);

  useEffect(() => {
    if (!users.length) {
      setUsersTable([]);
      return;
    }

    setUsersTable(
      users?.map((user: getUsersRes) => ({
        key: user.id,
        fullname: user.name,
        organization: user.organization ? user.organization.name : "",
        email: user.email,
        role: user.role,
        date: moment(user.createdAt).format("YYYY-MM-DD HH:mm:ss"),
      }))
    );
  }, [users]);

  const rowSelection = {
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: UsersTableType[]
    ) => {
      setSelected(selectedRows);
    },
  };

  const navigateToAddUser = () => {
    history.navigate(NavigationPath.ADD_USER_ROUTE);
  };

  const navigateToEdit = () => {
    if (!selected) {
      return;
    }
    history.navigate(`/edit-user/${selected[0].key}`);
  };

  const handleDeleteUser = () => {
    if (selected) {
      const userIds = selected.map((user: UsersTableType) => user.key);
      actions.deleteUser(userIds);
      setSelected(null);
    }
  };

  return (
    <div className="px-8 py-4">
      <div className="lg:flex justify-between mb-4">
        <ActionButtons
          navigateToAdd={navigateToAddUser}
          navigateToEdit={navigateToEdit}
          handleDelete={handleDeleteUser}
          selected={selected}
        />
        <div className="lg:flex">
          <Select
            value={!searchRole ? "Rola" : searchRole}
            variant="borderless"
            options={Object.values(ROLES).map((role) => ({
              label: role,
              value: role,
            }))}
            onChange={(e) => (!e ? setSearchRole("") : setSearchRole(e))}
            className="lg:max-w-40 mt-4 lg:mt-0"
            allowClear={searchRole ? true : false}
            onClear={() => setSearchRole("")}
          />
          <Search
            className="rounded-l-md rounded-r-sm xl:w-80 mt-4 lg:mt-0"
            placeholder="Traži po imenu / prezimenu korisnika"
            onSearch={(e) => setSearchUser(e)}
            enterButton
          />
        </div>
      </div>
      <Table
        columns={userColumns(searchUser, searchRole)}
        dataSource={usersTable}
        rowSelection={{
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default Users;
